import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { G, Mask, Path, Rect } from "react-native-svg";

const SvgSv = (props: SvgProps) => (
  <Svg width={22} height={16} fill="none" {...props}>
    <Rect width={22} height={16} fill="#fff" rx={2} />
    <Mask
      id="sv-flag"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <Rect width={22} height={16} fill="#fff" rx={2} />
    </Mask>
    <G mask="url(#sv-flag)">
      <Path fill="#157CBB" d="M0 0h22v16H0z" />
      <Path
        fill="#FFD34D"
        fillRule="evenodd"
        d="M0 9.6h6.286V16h3.143V9.6H22V6.4H9.429V0H6.286v6.4H0z"
        clipRule="evenodd"
      />
    </G>
  </Svg>
);
const Memo = memo(SvgSv);
export default Memo;
